import { render, staticRenderFns } from "./ib-tag.vue?vue&type=template&id=632f5109&lang=pug&"
import script from "./ib-tag.vue?vue&type=script&lang=js&"
export * from "./ib-tag.vue?vue&type=script&lang=js&"
import style0 from "./ib-tag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-tag.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632f5109')) {
      api.createRecord('632f5109', component.options)
    } else {
      api.reload('632f5109', component.options)
    }
    module.hot.accept("./ib-tag.vue?vue&type=template&id=632f5109&lang=pug&", function () {
      api.rerender('632f5109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/ib-tag.vue"
export default component.exports